
import { Component, Vue } from "vue-property-decorator";
import { Toast } from "vant";
import { Service } from "src/decorator";
import { rightsService } from "src/services";
import dayjs from "dayjs";

@Component
export default class PackageList extends Vue
{

    /**
     * 体检服务组id
     * @private
     * @returns number
     */
     private get groupId(): any
    {
        return this.$route.query.groupId;
    }


    /**
     * 订单id
     * @private
     * @returns number
     */
     private get orderId(): any
    {
        return this.$route.query.id;
    }

    private packageList = [];


    /**
     * 组件创建钩子
     * @private
     * @returns void
     */
     private created(): void
    {
        this.getPackageList();
    }


    /**
     * 套餐列表
     * @private
     * @returns void
     */
     private async getPackageList()
    {
      try
        {
          const {content:result} =  await rightsService.instance.getGroupProducts(this.orderId,this.groupId);
          this.packageList = result.data

        }
        catch(err)
        {
            Toast(err);
        }
    }


    /**
     * 套餐详情
     * @private
     * @returns void
     */
    private async onMakeAppointment(id,rightsId) {
      this.$router.push({name:"physical-package-detail",query:{id,rightsId}})
    }


}





